import { IGridFilterModel, IGridSortModel } from "src/components";
import { ApiResponse } from "src/services/core/ApiService";

export class GridState<T> extends ApiResponse<Array<T>> {
    constructor() {
        super();
        this.isLoading = false;
        this.pageSize = 100;
        this.page = 0;
        this.isFetching = false;
        this.data = [];
    }
    data?: T[] = !this.data ? [] : this.data;
    activeRow?: T;
    isLoading?: boolean;
    pageSize?: number;
    page?: number;
    isFetching?: boolean;
    sortModel?: IGridSortModel;
    filterModel?: IGridFilterModel;
}

